import React from 'react'
import Link from 'gatsby-link'

const Code = ({ code }) => (
    <p className="code" >
        {code}
    </p>
)

export default Code


// WEBPACK FOOTER //
// ./src/components/syntax.js